import { Box, Skeleton } from "@mui/material";

export const SkeletonVideoItem = (props: { itemKey: string | number }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Skeleton
                variant="rectangular"
                sx={{
                    width: '100%',
                    height: { xs: 140, sm: 150, md: 160, lg: 170 },
                    borderRadius: 2,
                }}
            />
            <Skeleton
                variant="text"
                sx={{
                    width: '80%',
                    height: 24,
                    mt: 1,
                }}
            />
            <Skeleton
                variant="text"
                sx={{
                    width: '40%',
                    height: 18,
                    mt: 0.5,
                }}
            />
        </Box>
    );
};
